import { render } from "./ScorePlayer.vue?vue&type=template&id=20e7a28e&scoped=true"
import script from "./ScorePlayer.vue?vue&type=script&lang=js"
export * from "./ScorePlayer.vue?vue&type=script&lang=js"

import "./ScorePlayer.vue?vue&type=style&index=0&id=20e7a28e&scoped=true&lang=css"

import exportComponent from "/home/lbecker/git/usssa-score/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e7a28e"]])

export default __exports__